import './collectionblock.less'

import {m} from '@codeurs/front'
import {Fragment, FunctionComponent, useState} from 'react'
import Popup from 'reactjs-popup'
import {style} from 'util/style'
import {Trusted} from 'util/trusted'
import {ImageLoader, isGif} from 'views/partials/imageloader'
import {Theme} from 'views/theme'
import {Block} from './blocks'
import {EmbedSwitch} from './embedblock'
import {ImageBlockType} from './imageblock'

export type CollectionBlockType = {
	columns?: 'columns2' | 'columns3'
	align?: 'top' | 'center'
	ratio?: boolean
	items: Array<MediaItemType>
}
type MediaItemType = ImageBlockType & {url: string}
const styles = style('collectionblock', ['item', 'image', 'video', 'portal'])

export const CollectionBlock: FunctionComponent<CollectionBlockType> = ({
	columns = 'columns2',
	align = 'top',
	ratio = false,
	items
}) => {
	// get block padding from items
	return (
		<Fragment>
			<Block class={styles.mod(align)}>
				{items.length > 0 &&
					items.map(item => (
						<div class={styles('item').mod(columns)}>
							{mediaSwitch(item, ratio)}
						</div>
					))}
			</Block>
		</Fragment>
	)
}

const CollectionVideo = ({video, text}) => {
	return (
		<div class={styles.video}>
			<EmbedSwitch {...video} videoPlayerProps={{controls: true}} />
			{text && (
				<div class={styles.image('text')}>
					<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
				</div>
			)}
		</div>
	)
}

const CollectionImage = ({image, text, ratio}) => {
	const [isOpen, setOpen] = useState(false)
	const asGif = isGif(image)

	return (
		<Fragment>
			<a class={styles.image()} onClick={() => setOpen(!isOpen)}>
				<ImageLoader ratio={ratio && 9 / 16} image={image} />
				{text && (
					<div class={styles.image('text')}>
						<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
					</div>
				)}
			</a>
			<Popup
				modal
				open={isOpen}
				onClose={() => setOpen(false)}
				className={styles.portal.toString()}
				contentStyle={{padding: 0, background: null, border: null}}
			>
				<div class={styles('modalview')} onClick={() => setOpen(!isOpen)}>
					{image && <ImageLoader image={image} gif={asGif} alt={image.alt} />}
					{text && <div class={styles.image('gradient')} />}
					{text && (
						<div class={styles.image('text')}>
							<Trusted>{text}</Trusted>
						</div>
					)}
				</div>
			</Popup>
		</Fragment>
	)
}

const mediaSwitch = (item, ratio) => {
	switch (item.type) {
		case 'video':
			return <CollectionVideo video={{...item}} text={item.text} />
		case 'image':
			return <CollectionImage {...item} ratio={ratio} />
	}
}
